import { ErrorPostRequestBody } from "#next/pages/api/error.api";
import { ConvertWebpackedStacktrace } from "#/lib/source-map/convert-webpacked-stacktrace";
import { fetchJson } from "#/utils/fetch";
import { Logger } from "#/lib/logging";
import { getApiUrl } from "#/constants/environment";


export const decodeStacktraceAction = async (
  { stacktrace }: ErrorPostRequestBody
): Promise<ConvertWebpackedStacktrace> => {

  const {
    data, failure
  } = await fetchJson(`${getApiUrl()}/api/error`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      stacktrace
    })
  });
  if (failure) {
    throw Logger.error({
      message: "Failed to fetch user action",
      error: failure.error,
      metadata: failure.metadata
    });
  }

  return data;
};